<section class="timeline">
  @for (item of timeline; track item) {
    <div class="action">
      <div>
        <p [style.color]="item.colour">
          @if (item.icon) {
            <i class="fa fa-fw {{item.icon}}"></i>
          }
          @if (item.logo) {
            <img width="24px" src="assets/svg/elogbooks-logo.svg">
          }
        </p>
        <span class="connector">{{item.connector}}</span>
      </div>
      <div>
        <p [innerHTML]="item.words"></p>
        <p class="date">
          @if (item.date) {
            <span>{{item.date | amDateFormat:'DD MMM YYYY HH:mm'}}</span>
          }
          @if (item.name) {
            <span><i>, <span class="">{{item.name}}</span></i></span>
          }
        </p>
      </div>
    </div>
  }
</section>
